import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditIncomePage = {
  alert: {
    error: 'applicant-edit-income-page.form.alert.error',
  },
  footer: {
    root: 'applicant-edit-income-page.footer.root',
  },
  form: {
    amountInput: 'applicant-edit-income-page.form.amount-input',
    amountInputError: 'applicant-edit-income-page.form.amount-input-error',
    cancelButton: 'applicant-edit-income-page.form.cancel-button',
    employerNameInput: 'applicant-edit-income-page.form.employer-name-input',
    employerNameInputError:
      'applicant-edit-income-page.form.employer-name-input-error',
    frequencySelect: 'applicant-edit-income-page.form.frequency-select',
    frequencySelectError:
      'applicant-edit-income-page.form.frequency-select-error',
    h1: 'applicant-edit-income-page.form.h1',
    h2: 'applicant-edit-income-page.form.h2',
    hasAdditionalIncomeSelect:
      'applicant-edit-income-page.form.has-additional-income-select',
    hasAdditionalIncomeSelectError:
      'applicant-edit-income-page.form.has-additional-income-select-error',
    incomeTypeSelect: 'applicant-edit-income-page.form.income-type-select',
    incomeTypeSelectError:
      'applicant-edit-income-page.form.income-type-select-error',
    jobTitleInput: 'applicant-edit-income-page.form.job-title-input',
    jobTitleInputError: 'applicant-edit-income-page.form.job-title-input-error',
    monthSelect: 'applicant-edit-income-page.form.month-select',
    monthSelectError: 'applicant-edit-income-page.form.month-select-error',
    root: 'applicant-edit-income-page.form.root',
    submitButton: 'applicant-edit-income-page.form.submit-button',
    yearSelect: 'applicant-edit-income-page.form.year-select',
    yearSelectError: 'applicant-edit-income-page.form.year-select-error',
  },
  header: {
    drawerButton: 'applicant-edit-income-page.header.drawer-button',
    previousStepButton:
      'applicant-edit-income-page.header.previous-step-button',
    root: 'applicant-edit-income-page.header.root',
  },
  progress: {
    root: 'applicant-edit-income-page.progress.root',
  },
} as const satisfies PageLocatorMap;
